<section class="job-page">
  <app-job-page-header [state]="headerState()"></app-job-page-header>
  @if (jobId) {
    @if (!numericJobId) {
      <p class="job-page__feedback">This run ID is invalid.</p>
    } @else if (jobError()) {
      <p class="job-page__feedback">This run could not be loaded.</p>
    } @else if (tool(); as tool) {
      <div
        class="job-page__timeline"
        [class.job-page__timeline--refreshing]="
          toolJob.status() === 'loading' && !!toolJob.value()
        ">
        <app-job-timeline
          [job]="toolJob.value()"
          [tool]="tool"
          [isInitialLoading]="isInitialLoading()"></app-job-timeline>
      </div>
    }
  } @else {
    <div class="job-page__timeline">
      @if (tool(); as tool) {
        <app-job-timeline
          [tool]="tool"
          [startJob]="startToolJob"
          (jobStarting)="isStartingJob.set($event)"></app-job-timeline>
      }
    </div>
  }
</section>
